module.exports = __webpack_public_path__ + "img/Christmasbrick-blk.de443cca.png";